import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { TokenService } from './services/token.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from './services/api.service';
import { ThemeService } from './services/themes.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ChatbotComponent } from './chatbot/chatbot.component';
import { environment } from 'src/environments/environment';
import { Subscription, timer } from 'rxjs';
import { RedirectToLoginComponent } from './components/redirect-to-login/redirect-to-login.component';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        trigger('fadeInAnimation', [
            transition(':enter', [ // When the element is added
                style({ opacity: 0 }),
                animate('500ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [ // When the element is removed
                animate('500ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ],
})
export class AppComponent implements OnInit, OnDestroy {

    environment = environment;
    idleTime = 0;
    isAtTop: any;
    idleSubscription!: Subscription;
    themedata: any;
    selectedRegion: any;
    slides: any = [];
    pageroute: string = "";
    isTokenAvailable: boolean = false;
    showConfidential: boolean = false;

    constructor(
        private router: Router,
        private themeService: ThemeService,
        private tokenService: TokenService,
        private spinnerService: NgxSpinnerService,
        private cookieService: CookieService,
        private apiService: ApiService,
        private dialog: MatDialog,
    ) { }

    async ngOnInit() {
        try {
            this.themeService.theme$.subscribe((response) => {
                this.themedata = response;
            });

            this.apiService.keyboardActions$.subscribe((response) => {
                this.showConfidential = response;
            });

            this.themeService.selectedRegion$.subscribe((response) => {
                this.selectedRegion = response;
            });

            // this.apiService.getIpAddress();
            this.startIdleTimer();

            const currentUrl = window.location.hostname;
            if (currentUrl.endsWith('.com')) {
                this.themeService._selectedRegion.next("USA");
            } else if (currentUrl.endsWith('.in')) {
                this.themeService._selectedRegion.next("INDIA");
            }

            this.apiService.getUserAccountDetails().then(
                (response) => {
                    // handle response
                }, (error) => {
                    this.apiService.profileCheckSubject.next(false);
                }
            );

            // const response: any = await this.apiService.getMyAccountDetails();
            // if (response) {
            //     this.isTokenAvailable = true;
            // }
        } catch (error: any) {
            this.spinnerService.hide();
            throw error;
        }
    }

    navigateToHelpPage() {
        this.router.navigate(['/', 'contact-us']);
    }

    scrollToTop() {
        window.scroll({ top: 0, behavior: 'smooth' });
    }

    goToPreviousPage() {
        window.history.back();
    }

    openChatbotModal() {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.maxWidth = '70%';
        dialogConfig.position = {
            right: '7rem',
            bottom: '6rem'
        }

        const dialogRef = this.dialog.open(ChatbotComponent, dialogConfig);
    }

    alertUser(): void {
        this.resetIdleTime();
        if (this.isTokenAvailable) {
            const dialogRef = this.dialog.open(RedirectToLoginComponent, {
                width: '60%',
                data: {
                    title: "You have been idle for too long"
                },
                disableClose: true,
            });
        }
    }

    resetIdleTime(): void {
        this.idleTime = 0;
    }

    startIdleTimer(): void {
        this.idleSubscription = timer(0, 1000).subscribe(() => {
            this.idleTime++;
            if (this.idleTime >= environment.IDLE_LIMIT) {
                this.alertUser();
            }
        });
    }

    @HostListener('window:scroll', [])
    onScroll(): void {
    }

    @HostListener('window:mousemove')
    @HostListener('window:keydown')
    @HostListener('window:click')
    @HostListener('window:scroll')
    @HostListener('window:focus')
    @HostListener('window:beforeprint')
    onUserActivity(): void {
        this.resetIdleTime();

        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        this.isAtTop = scrollTop === 0;
    }

    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        const isCtrl = event.ctrlKey;
        const isAlt = event.altKey;
        const isShift = event.shiftKey;
        const isWindows = event.metaKey || event.code === "Meta";

        if (isCtrl && event.key === 'c') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && event.key === 'x') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && event.key === 'v') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && event.key === 'z') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && event.key === 'y') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && event.key === 'a') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (event.key === 'Delete' && !isShift) {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isShift && event.key === 'Delete') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        }

        else if (isAlt && event.key === 'Tab') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && event.key === 'd') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && event.key === 'e') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && event.key === 'l') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && event.key === 'Escape') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && event.key === 'm' && !isShift) {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && isShift && event.key === 'M') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isAlt && event.key === 'F4') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        }

        else if (event.key === 'PrintScreen') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && isShift && event.key === 'P') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isAlt && event.key === 'PrintScreen') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && isShift && event.key === 'S') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isCtrl && isShift && event.key === 'Escape') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && event.key === 'r') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (isWindows && event.key === 'i') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        } else if (event.key === 'F2') {
            event.preventDefault();
            this.apiService.keyboardActionsSubject.next(true);
        }
    }

    ngOnDestroy(): void {
        this.cookieService.delete('region', "/", location.host);
        if (this.idleSubscription) {
            this.idleSubscription.unsubscribe();
        }
    }
}
